/**
 * 本人档案（/api/person/me）
 * ------------------------------------------------------------
 * 人员基本信息 + 组织信息（工号 / 手机 / 邮箱 / 部门 / 主属组织）。
 * 与 auth-store 分工：auth 管会话身份与权限，person 管档案资料。
 * 顶栏档案卡等本人资料展示取用；接口失败时保持 null，由展示方按空值回落，
 * 不把未知数据显示成 fixture。
 */
import { ref } from 'vue'
import { apiGet } from './http-client'

export interface PersonMe {
  id: string
  name: string
  nickname: string
  /** 工号（HR 主数据口径，管理员维护；空 = 未登记，不展示工号标识） */
  empNo: string
  phone: string
  email: string
  deptId: string | null
  deptName: string
  /** 主属组织 = 部门物化路径的根部门（无部门时为空） */
  orgId: string | null
  orgName: string
}

const me = ref<PersonMe | null>(null)
let loadedFor = ''

export const personMe = me

/** 拉取本人档案；按 personId 缓存，换人登录需重新调用 */
export async function ensurePersonMe(personId: string, force = false): Promise<PersonMe | null> {
  if (!force && me.value && loadedFor === personId) return me.value
  loadedFor = personId
  try {
    me.value = await apiGet<PersonMe>('/api/person/me')
  } catch {
    me.value = null
  }
  return me.value
}

export function clearPersonMe(): void {
  me.value = null
  loadedFor = ''
}
